module.exports = __webpack_public_path__ + "static/media/privacy_no-more-targeted-ads.0af800fc.svg";